import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LOAD_APPLICATIONS_FROM_SUBDOMAIN, LOAD_RAW_SCHEMA, PARSE_SCHEMA } from "@Client/@Modules/deprecated-application/store/application-actions";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { APPLICATIONS_BY_SUBDOMAIN } from "@Client/@Modules/deprecated-application/store/application-getters";
import { IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK, CURRENT_BROKERAGE_DETAILS, GET_ACCOUNT_AGENTS } from "@Client/@Modules/main/store/account/account-getters";
import { LOAD_ACCOUNT_AGENTS } from "@Client/@Modules/main/store/account/account-actions";
import Err from "@Client/@Routes/error";
import { SET_SELECTED_APPLICATION_ID, SET_BROKERAGE_SUBDOMAIN, SET_ACCOUNT_SUBDOMAIN } from "@Client/@Modules/main/store/account/account-mutations";
import InterstitialNavbar from "./interstitial-navbar.vue";
import InterstitialApplications from "./interstitial-applications.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import NewAppModal from "@Client/@Modules/subdomain-interstitial/new-application-modal.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SubdomainInterstitialLoader from "./subdomain-interstitial-loader.vue";
import SpinnerLoader from "@Shared/components/loaders/page-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEmpty, orderBy, trimStart } from "lodash";
import StartAppModal from "@Client/@Modules/subdomain-interstitial/start-application-modal.vue";
import { defineComponent } from "@vue/composition-api";
import { GRAVEYARD_BROKERAGE_ID } from "@Shared/js/constants";
export default defineComponent({
  name: "SubdomainInterstitial",
  title() {
    return this.$t("sidebar.sections.subdomainInterstitial");
  },
  components: {
    InterstitialNavbar,
    InterstitialApplications,
    SimpleButton,
    SubdomainInterstitialLoader,
    SpinnerLoader,
    NewAppModal,
    StartAppModal
  },
  mixins: [validationMixin],
  validations: {
    selectedApplicationId: {
      required
    },
    selectedSubdomain: {
      required
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      var _context;
      vm.fromRegistration = _includesInstanceProperty(_context = from.path).call(_context, "registration");
    });
  },
  props: {
    force: {
      type: Boolean,
      default: false
    },
    startUrl: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      showSpinner: true,
      fromRegistration: false,
      startSubdomain: !this.force && window.location.pathname.replace("/", "").replace("#", ""),
      loading: true,
      selectedBrokerageId: "",
      selectedApplicationId: null,
      selectedSubdomain: null,
      selectingApplication: {
        loading: false,
        loadingSucceeded: true
      },
      showModal: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("DeprecatedApplicationStore", [APPLICATIONS_BY_SUBDOMAIN])), mapGetters("AccountStore", [IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK, CURRENT_BROKERAGE_DETAILS, GET_ACCOUNT_AGENTS])), mapState("DeprecatedApplicationStore", {
    applications(state) {
      return state.applications;
    }
  })), mapState("AccountStore", {
    tiedBrokerages(state) {
      var _context2;
      return _filterInstanceProperty(_context2 = state.brokerageDetails.tiedBrokerages).call(_context2, brokerage => brokerage.brokerageId !== GRAVEYARD_BROKERAGE_ID && state.agents.agents.some(agent => agent.brokerage_id === brokerage.brokerageId));
    },
    storedSelectedApplicationId(state) {
      return state.selectedApplicationId;
    }
  })), {}, {
    agents() {
      return this.GET_ACCOUNT_AGENTS.agents;
    },
    path() {
      return window.location.pathname.replace("/", "").replace("#", "");
    },
    defaultSubdomain() {
      return _Object$keys(this.APPLICATIONS_BY_SUBDOMAIN)[0];
    },
    selectedApplicationStatus() {
      if (!this.selectedApplicationId && !this.storedSelectedApplicationId) return;
      const applicationId = this.selectedApplicationId || this.storedSelectedApplicationId;
      return this.applications.byId[applicationId].applicationStatus;
    },
    lastBrokerNameByBrokerage() {
      const latestApplicationByBrokerage = {};
      this.agents.forEach(agent => {
        const brokerageName = agent.brokerage_name;
        if (!brokerageName || !agent.application) return;
        const existingApplication = latestApplicationByBrokerage[brokerageName];
        if (!existingApplication || new Date(agent.application.createdAt) > new Date(existingApplication.createdAt)) {
          latestApplicationByBrokerage[brokerageName] = _objectSpread(_objectSpread({}, agent.application), {}, {
            agentDetails: {
              givenName: agent.givenName,
              familyName: agent.familyName
            }
          });
        }
      });
      const lastBrokerNameByBrokerage = {};
      _Object$keys(latestApplicationByBrokerage).forEach(brokerageName => {
        const application = latestApplicationByBrokerage[brokerageName];
        lastBrokerNameByBrokerage[brokerageName] = application.agentDetails.givenName + " " + application.agentDetails.familyName;
      });
      return lastBrokerNameByBrokerage;
    }
  }),
  watch: {
    async selectedBrokerageId(brokerageId) {
      this.loading = true;
      this.SET_BROKERAGE_SUBDOMAIN({
        brokerageId
      });
      await this.loadApplications();
      this.loading = false;
    }
  },
  async mounted() {
    var _context3;
    this.showSpinner = true;
    await this.loadApplications();
    Amplitude.logEvent("Subdomain Interstitial - visited");
    this.showSpinner = false;
    this.loading = true;
    await this.LOAD_RAW_SCHEMA({
      subdomain: this.defaultSubdomain
    });
    await this.PARSE_SCHEMA({
      subdomain: this.defaultSubdomain
    });
    await this.LOAD_ACCOUNT_AGENTS();
    const shouldShowInterstitial = await this.shouldShowInterstitial();
    if (!shouldShowInterstitial) return;
    if (_findInstanceProperty(_context3 = this.agents).call(_context3, agent => agent.subdomain === this.path)) {
      var _context4;
      this.selectedBrokerageId = _findInstanceProperty(_context4 = this.agents).call(_context4, agent => agent.subdomain === this.path).brokerage_id;
    } else if (this.path != "") {
      this.selectedBrokerageId = "";
      this.showModal = true;
    }
    this.loading = false;
  },
  async updated() {
    if (this.showModal) {
      this.$refs.startApplicationModal.openModal();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("DeprecatedApplicationStore", [LOAD_APPLICATIONS_FROM_SUBDOMAIN, LOAD_RAW_SCHEMA, PARSE_SCHEMA])), mapActions("AccountStore", [LOAD_ACCOUNT_AGENTS])), mapMutations("AccountStore", [SET_SELECTED_APPLICATION_ID, SET_BROKERAGE_SUBDOMAIN, SET_ACCOUNT_SUBDOMAIN])), {}, {
    async loadApplications() {
      await this.LOAD_APPLICATIONS_FROM_SUBDOMAIN({
        subdomain: this.startSubdomain
      });
    },
    handleSelectApplication() {
      this.continueWithApp(this.selectedApplicationId, this.selectedSubdomain);
    },
    async shouldShowInterstitial() {
      await this.$nextTick();
      try {
        var _context5;
        if (this.tiedBrokerages.length > 1) return true;
        if (!this.startDomain && isEmpty(this.APPLICATIONS_BY_SUBDOMAIN)) {
          var _this$applications, _this$applications$al;
          Amplitude.logEvent("Subdomain Interstitial - error if should show interstitial", {
            startDomain: this.startDomain,
            applicationsLength: (_this$applications = this.applications) == null ? void 0 : (_this$applications$al = _this$applications.allIds) == null ? void 0 : _this$applications$al.length
          });
          this.$auth.session.end();
          throw new Error("NotAuthorizedException");
        }
        const applicationsCount = this.applications.allIds.length;
        if (applicationsCount === 1 && _findInstanceProperty(_context5 = this.agents).call(_context5, agent => agent.subdomain === this.path)) {
          const domain = _Object$keys(this.APPLICATIONS_BY_SUBDOMAIN)[0];
          const [{
            applicationId
          }] = this.APPLICATIONS_BY_SUBDOMAIN[domain];
          await this.continueWithApp(applicationId, domain);
          return;
        }
        if (applicationsCount === 0) {
          this.hardRedirect("#/application");
          return;
        }
        return true;
      } catch (e) {
        Err.handle(e, {}, !(e != null && e.responseJSON) && e.message);
      }
    },
    hardRedirect(href) {
      return window.location.href = href;
    },
    handleNewAppModal() {
      this.$refs.newApplicationModal.openModal();
    },
    async handleGoToDashboard() {
      var _this$selectedApplica, _this$selectedSubdoma;
      const allApplications = orderBy(this.applications.allIds, null, "desc");
      const applicationId = (_this$selectedApplica = this.selectedApplicationId) != null ? _this$selectedApplica : allApplications[0];
      const subdomain = (_this$selectedSubdoma = this.selectedSubdomain) != null ? _this$selectedSubdoma : this.defaultSubdomain;
      await this.SET_SELECTED_APPLICATION_ID({
        applicationId
      });
      await this.SET_ACCOUNT_SUBDOMAIN({
        subdomain
      });
      location.replace(`/${subdomain}`);
    },
    async continueWithApp(applicationId, subdomain) {
      this.logIdentityToAmplitude({
        subdomain,
        applicationId
      });
      try {
        this.SET_SELECTED_APPLICATION_ID({
          applicationId
        });
        this.SET_ACCOUNT_SUBDOMAIN({
          subdomain
        });
        this.redirectFromStatus(subdomain);
      } catch (e) {
        const message = "We couldn't load application data, try again";
        Err.handle(e, {}, message);
      }
    },
    redirectFromStatus(subdomain) {
      const isPending = this.selectedApplicationStatus === "pending";
      const isNew = this.selectedApplicationStatus === "new";
      const redirectToApp = isNew || isPending;
      let startUrl = this.startUrl;
      if (redirectToApp || this.fromRegistration) {
        startUrl = "application";
      }
      if (isPending) startUrl += "?nt=true";
      if (this.IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK) {
        return this.$router.push({
          path: "/application-widget/application"
        });
      }
      const hash = trimStart(startUrl, "/");
      return location.replace(`/${subdomain}#/${hash}`);
    },
    logIdentityToAmplitude({
      applicationId,
      subdomain
    }) {
      Amplitude.setToIdentityKey(Amplitude.IDENTITY_APPLICATION_IDS, applicationId);
      Amplitude.setToIdentityKey(Amplitude.IDENTITY_SUBDOMAIN, subdomain);
    }
  })
});